import React from 'react'
import { browserHistory } from 'react-router'

import THREE from 'particlespace-graphics-engine'

import CanvasComponent from '../../components/Graphics/CanvasComponent.jsx'
import GraphicsEditor from '../../components/Graphics/Editor/'

import {buildings} from '../../core/controllers/Buildings'
import {levelHandler} from '../../core/graphic_engine/controllers/LevelHandler'
import {user} from '../../core/controllers/user';
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'

export default class LevelEditorTempalte extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateCanvas: false,
            renderer: new THREE.CanvasRenderer(),
            data: null,
            building_level_total: null,
            levelData:null,
            buildingID: this.props.buildingID,
            buildingName: this.props.buildingName,
            levelID: this.props.levelID,
            spaceID: this.props.spaceID,
            canvasID: "level-overview",
            taskData: null,
            triggerMultiTask: false,
            curUrl: window.location.pathname,
            firstTimeLoad: true
        }
    }

    componentDidMount() {
        buildings.getBuilding(this);
    }

    componentWillUnmount() {
        levelHandler.stopWindowTimeouts();
    }

    componentDidUpdate() {
        if(this.state.data != null && this.state.updateCanvas != true) {
            levelHandler.init(this);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.firstTimeLoad || nextProps.levelID != this.state.levelID) {
            nextState.triggerMultiTask = false;
            nextState.taskData = null;
            nextState.curUrl = window.location.pathname;
            nextState.updateCanvas = false;
            nextState.levelID = nextProps.levelID;

            buildings.getBuilding(this);
            nextState.firstTimeLoad = false;
        }
    }

    goBack() {
        browserHistory.replace('/building/' + this.props.buildingID)
    }

    render(){
        if(this.state.triggerMultiTask) {
            var type = 'space';
            if(this.state.taskData.isSensor) {
                type = 'sensor';
            }
            multiTaskerManager.setData(this.state.taskData, type);
        }
        return (
            <div>
                <div class="col-md-12">
                    <span class="go-back go-back-left-side" onClick={this.goBack.bind(this)}><i class="icon-arrow-left"></i></span>
                    <div class="content">
                        <GraphicsEditor buildingData={this.state.data} buildingID={this.props.buildingID} levelID={this.props.levelID} totalBuildingLevel={this.state.building_level_total} />
                        <CanvasComponent domID={this.state.canvasID} classID="" renderer={this.state.renderer} updateCanvas={this.state.updateCanvas}/>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/LevelEditor/LevelEditor.jsx